import React from "react";

const RoomBookingContext = React.createContext();

export default RoomBookingContext;
